import styled from "styled-components";

export const Overlay = styled.div`
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	z-index: 50;
`;

export const Modal = styled.div`
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: calc(100% - 20px);
	max-height: calc(100% - 20px);
	overflow: auto;
	max-width: 600px;
	min-height: 200px;
	background: #545456;
	color: ${({theme}) => theme.color.tertiary};
	border-radius: 4px;
	box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
	z-index: 51;

	&.full-screen {
		${({theme}) => theme.breakpoints.down("mobile")} {
			border-radius: 0;
			width: 100%;
			height: 100%;
			max-height: 100%;
			max-width: 100%;
		}
	}

	&.grey {
		background: #545456;
		color: ${({theme}) => theme.color.tertiary};
	}
`;

export const ModalInner = styled.div`
	position: relative;
	padding: 64px 20px 40px;

	${({theme}) => theme.breakpoints.up("mobile")} {
		padding: 64px 20px 40px;
	}
`;

export const ModalContent = styled.div`
	text-align: center;
`;

export const ButtonsBox = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	gap: 20px;

	button,
	a {
		width: 100%;
		align-self: stretch;
	}

	${({theme}) => theme.breakpoints.up("mobile")} {
		flex-direction: row;

		button,
		a {
			max-width: 300px;
		}
	}
`;

export const ModalTitle = styled.h4`
	font-size: 20px;
	line-height: 20px;
	letter-spacing: 0.2px;
	margin-bottom: 20px;
`;

export const ModalText = styled.p`
	font-size: 16px;
	line-height: 24px;
	margin-bottom: 20px;
	font-family: "Hind", sans-serif;
`;

export const ModalIcon = styled.img`
	width: 80px;
	height: auto;
	margin-bottom: 20px;

	&.small {
		width: 50px;
	}
`;

export const ModalSvgIconContainer = styled.div`
	margin-bottom: 20px;

	svg {
		width: 80px;
		height: auto;
	}

	&.small {
		svg {
			width: 50px;
		}
	}
`;
